export function getData(form) {
    let objData = {};
    const formData = new FormData(form);
    for (var key of formData.keys()) {
        objData[key] = formData.get(key);
    }
    return objData
}
